import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "nearbyDevice"
const NearbyDeviceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 9C13.036 9 13.875 9.84 13.875 10.875S13.035 12.75 12 12.75 10.125 11.91 10.125 10.875 10.965 9 12 9" />
          <path
            fillRule="evenodd"
            d="M12 5.25C15.057 5.25 17.625 7.412 17.625 10.715 17.625 12.71 16.343 14.71 15.152 16.125 14.541 16.854 13.915 17.47 13.414 17.909 13.164 18.128 12.936 18.308 12.749 18.44 12.657 18.505 12.564 18.567 12.475 18.615 12.43 18.64 12.375 18.667 12.313 18.69 12.265 18.708 12.148 18.75 12 18.75S11.735 18.708 11.687 18.69Q11.593 18.653 11.525 18.615C11.436 18.567 11.343 18.505 11.251 18.44 11.064 18.31 10.836 18.127 10.586 17.908 10.085 17.47 9.46 16.853 8.848 16.126 7.658 14.71 6.375 12.71 6.375 10.715 6.375 7.412 8.943 5.25 12 5.25M12 6.75C9.672 6.75 7.875 8.336 7.875 10.715 7.875 12.146 8.843 13.789 9.996 15.16 10.556 15.825 11.126 16.388 11.574 16.78 11.738 16.922 11.884 17.037 12 17.126 12.117 17.038 12.262 16.923 12.426 16.779 12.874 16.388 13.444 15.825 14.004 15.16 15.157 13.79 16.124 12.147 16.125 10.716 16.125 8.336 14.328 6.75 12 6.75"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default NearbyDeviceIcon
